import { Component, HostListener, OnInit } from '@angular/core';
import { EventsService } from 'src/app/service/events.service';
import { Event } from 'src/app/model/event';
import { ActivatedRoute, Router } from '@angular/router';
import { NavbarService } from 'src/app/service/navbar.service';
import { NO_PAGINATION } from 'src/app/model/pagination.options';
import { ShowAllPagedViewDirective } from 'src/app/class/paged-view-all';
import { PreferencesService } from 'src/app/service/preferences.service';
import { LocalCache } from 'src/app/enum/local.cache';
import { AuthService } from 'src/app/service/auth.service';
import { B } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent extends ShowAllPagedViewDirective {

  search: string;

  // Sticky header — flag de scroll usada pra ativar `.is-scrolled`
  // (border-bottom + box-shadow no header fixo).
  public isScrolled = false;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isScrolled = window.scrollY > 4;
  }

  constructor(
    private eventsService: EventsService,
    public navbarService: NavbarService,
    public preferencesService: PreferencesService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super(preferencesService, LocalCache.OLD_EVENTS);
  }

  // Override do getter da classe-base: o template de Eventos não tem mais
  // o toggle "Incluir eventos antigos" (foi removido). O modo "mostrar todos"
  // agora é ativado via query param `?show=all`, usado pelo item de menu
  // "Mostrar todos os eventos" do user-menu (visível só pra admin). Sem o
  // param, comportamento padrão (apenas ativos).
  public get showAll(): 'all' | 'active' {
    return this.route.snapshot.queryParamMap.get('show') === 'all' ? 'all' : 'active';
  }

  // Navegação programática usada pelos atalhos do estado vazio. Evita o
  // `href` do <a routerLink>, que expõe a URL na barra de status do navegador.
  goTo(path: string): void {
    this.router.navigate([path]);
  }

  load() {
    setTimeout(() => {
      this.getEvents();
    });
    // Re-fetch quando o query param `show` muda — Angular reusa o
    // EventsComponent ao alternar entre `/events` e `/events?show=all`,
    // então o ngOnInit (que chama load uma única vez) não dispararia
    // de novo. Skip do primeiro emit pra não duplicar a chamada acima.
    let firstEmit = true;
    this.route.queryParamMap.subscribe(() => {
      if (firstEmit) { firstEmit = false; return; }
      this.getEvents();
    });
  }

  get events(): Array<Event> {
    return <Array<Event>>this.elements;
  }

  getEvents(): void {
    this.navbarService.loadingStart();
    const paginationOptions = NO_PAGINATION;
    paginationOptions.show = this.showAll;
    this.eventsService.getAllEventsWithMinimumDetails(paginationOptions).subscribe(pagination => {
      this.unfilteredElements = pagination as Event[];
      this.elements = this.unfilteredElements;

      this.elements = this.getSubEvents(this.elements);
      this.navbarService.loadingStop();
      window.scroll(0, 0);
    });
  }

  getSubEvents(elements: Event[]) {
    let events: Event[];
    let subEvents: Event[];
    events = elements.filter(event => !event.eventParent);
    subEvents = elements.filter(event => event.eventParent);
    events.map (event => {
      event.subEvents = subEvents.filter(child => child.eventParent == event.id);
    });
    return events;
  }
}
